import app from 'js/aofl-js/0.8.0/app/app';
import serviceImpl from './index-impl';

app.registerService('featureService', ['riqApiService', serviceImpl]);
